import * as tslib_1 from "tslib";
import { HttpClient } from '@angular/common/http';
import { AfterViewInit, ElementRef, EventEmitter, ViewContainerRef } from '@angular/core';
import { environment } from '../../../environment';
import { ESRI } from '../../../esri-loader-util';
import { ImportService } from '../../../services/import.service';
import { LayerService } from '../../../services/layer.service';
import { BaseComponent } from '../../base.component';
var AddExternalLayerComponent = /** @class */ (function (_super) {
    tslib_1.__extends(AddExternalLayerComponent, _super);
    function AddExternalLayerComponent(_vcr, layerService, importService, httpClient) {
        var _this = _super.call(this, _vcr, true) || this;
        _this.layerService = layerService;
        _this.importService = importService;
        _this.httpClient = httpClient;
        _this.loadingInd = false;
        _this.warnMsg = '';
        _this.fetchSuccess = false;
        _this.externalLayerFilterEnabled = environment.externalLayerFilterEnabled;
        _this.onreset = new EventEmitter();
        _this.onclose = new EventEmitter();
        _this.registerEvent('onreset', _this.onreset);
        _this.registerEvent('onclose', _this.onclose);
        return _this;
    }
    AddExternalLayerComponent.prototype.ngAfterViewInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.setupMapViewRef(this.mapViewRef)];
                    case 1:
                        _a.mapViewRef = _b.sent();
                        this.isReady();
                        return [2 /*return*/];
                }
            });
        });
    };
    AddExternalLayerComponent.prototype.addToMap = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var layerProps, error_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.layerResult) return [3 /*break*/, 6];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, this.layerService.getExternalServiceProperties({ url: this.layerResult.url })];
                    case 2:
                        layerProps = _a.sent();
                        return [4 /*yield*/, this.layerService.addExternalLayersToMap(layerProps)];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        error_1 = _a.sent();
                        this.warnMsg = 'Error adding external layer to map';
                        return [3 /*break*/, 5];
                    case 5: return [3 /*break*/, 8];
                    case 6:
                        if (!this.dynamicMapServiceResult) return [3 /*break*/, 8];
                        this.prepareExternalLayer(this.dynamicMapServiceResult);
                        return [4 /*yield*/, this.addMapImageLayerWithSelectedLayers()];
                    case 7:
                        _a.sent();
                        delete this.dynamicMapServiceResult.layers;
                        _a.label = 8;
                    case 8:
                        this.close();
                        return [2 /*return*/];
                }
            });
        });
    };
    AddExternalLayerComponent.prototype.addMapImageLayerWithSelectedLayers = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_1, _a, addPromises, _b, _c, layer, properties;
            return tslib_1.__generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        addPromises = [];
                        try {
                            for (_b = tslib_1.__values(this.dynamicMapServiceResult.layers.filter(function (l) { return l.visible; })), _c = _b.next(); !_c.done; _c = _b.next()) {
                                layer = _c.value;
                                properties = { url: this.dynamicMapServiceResult.url + "/" + layer.id };
                                addPromises.push(this.layerService.addExternalLayersToMap(properties, { url: properties.url, name: layer.name }));
                            }
                        }
                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
                        finally {
                            try {
                                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                            }
                            finally { if (e_1) throw e_1.error; }
                        }
                        return [4 /*yield*/, Promise.all(addPromises)];
                    case 1:
                        _d.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    AddExternalLayerComponent.prototype.prepareExternalLayer = function (layer) {
        layer.filter = this.layerFilter;
        layer.displayName = this.layerTitle;
        layer.isWMS = this.isWMS();
    };
    AddExternalLayerComponent.prototype.resetForm = function () {
        this.layerUrl = null;
        this.dynamicMapServiceResult = null;
        this.layerResult = null;
        this.fetchSuccess = false;
        this.layerFilter = null;
        this.warnMsg = '';
        this.onreset.emit();
    };
    AddExternalLayerComponent.prototype.fetchUrl = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.warnMsg = '';
                        this.loadingInd = true;
                        this.layerResult = null;
                        this.fetchSuccess = false;
                        this.dynamicMapServiceResult = null;
                        this.layerUrl = this.layerUrl.trim();
                        // if mapcore is loaded over https, convert external layer to https to prevent mixed-content error.
                        if (window.location.href.indexOf('https:') >= 0) {
                            if (this.layerUrl.indexOf('http:') >= 0) {
                                this.layerUrl = this.layerUrl.replace(/^http:/, 'https:');
                            }
                        }
                        if (!this.isWMS()) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.fetchWMSServiceCapabilities({ url: this.layerUrl })];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 6];
                    case 2:
                        if (!/^https?:\/\/.*\/[0-9]{1,}$/.test(this.layerUrl)) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.fetchFeatureLayerSymbols()];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 6];
                    case 4: return [4 /*yield*/, this.fetchDynamicServiceLayerList({ url: this.layerUrl })];
                    case 5:
                        _a.sent();
                        _a.label = 6;
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    AddExternalLayerComponent.prototype.isWMS = function () {
        return (this.layerUrl && (this.layerUrl.indexOf('WMSServer') > 0 || this.layerUrl.indexOf('SERVICE=WMS') > 0));
    };
    AddExternalLayerComponent.prototype.fetchFeatureLayerSymbols = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var serviceProps, layerResult, _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.layerService.getExternalServiceProperties({ url: this.layerUrl })];
                    case 1:
                        serviceProps = _b.sent();
                        return [4 /*yield*/, this.layerService.getExternalLayerSymbolData({ url: this.layerUrl })];
                    case 2:
                        layerResult = _b.sent();
                        this.loadingInd = false;
                        if (serviceProps.supportsAdvancedQueries) {
                            layerResult.supportsAdvancedQueries = serviceProps.supportsAdvancedQueries; // does the service support selecting distinct values
                        }
                        if (layerResult) {
                            this.warnMsg = '';
                            this.layerTitle = layerResult.name || layerResult.displayName || '';
                            this.layerResult = layerResult;
                            this.fetchSuccess = true;
                        }
                        else {
                            this.warnMsg = 'Layer Not Found.';
                            this.layerResult = null;
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        _a = _b.sent();
                        this.warnMsg = 'Error loading layer URL.';
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    AddExternalLayerComponent.prototype.fetchDynamicServiceLayerList = function (layer) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var esriRequest, response, urlParts, partLength, extraLength, _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, ESRI.Request];
                    case 1:
                        esriRequest = (_b.sent());
                        _b.label = 2;
                    case 2:
                        _b.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, esriRequest(layer.url + "?f=json", {
                                responseType: 'json'
                            })];
                    case 3:
                        response = _b.sent();
                        this.dynamicMapServiceResult = response.data;
                        this.dynamicMapServiceResult.url = layer.url;
                        if (this.dynamicMapServiceResult.documentInfo && this.dynamicMapServiceResult.documentInfo.Title) {
                            this.layerTitle = this.dynamicMapServiceResult.documentInfo.Title;
                        }
                        else {
                            urlParts = layer.url.split('/');
                            partLength = 3;
                            extraLength = 2;
                            if (urlParts.length > partLength) {
                                this.layerTitle = urlParts[urlParts.length - extraLength];
                            }
                        }
                        this.fetchSuccess = true;
                        return [3 /*break*/, 5];
                    case 4:
                        _a = _b.sent();
                        this.warnMsg = 'Error loading layer URL.';
                        return [3 /*break*/, 5];
                    case 5:
                        this.loadingInd = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    AddExternalLayerComponent.prototype.fetchWMSServiceCapabilities = function (layer) {
        var _this = this;
        this.dynamicMapServiceResult = {};
        this.dynamicMapServiceResult.layers = [];
        var questionMarkIndex = layer.url.indexOf('?');
        if (questionMarkIndex > 0) {
            layer.url = layer.url.substring(0, layer.url.indexOf('?'));
        }
        var url = environment.gisSearch.baseUrl + "/proxy?" + layer.url + "?SERVICE=WMS&REQUEST=GetCapabilities";
        this.httpClient.get(url, { withCredentials: true }).subscribe(function (result) {
            if (result.data && result.data.result && result.data.result.Message) {
                _this.warnMsg = result.data.result.Message;
            }
            else if (result.data) {
                var httpResult = result.data;
                var xml = (new window.DOMParser()).parseFromString(httpResult, 'text/xml');
                var layerCollection = xml.getElementsByTagName('Layer');
                if (layerCollection) {
                    var layers = Array.prototype.slice.call(layerCollection);
                    layers.forEach(function (lyr) {
                        var titles = lyr.getElementsByTagName('Title');
                        var names = lyr.getElementsByTagName('Name');
                        var nameLen = 2;
                        if (titles.length && titles.length <= nameLen && names.length && names.length <= nameLen) {
                            var title = titles[0];
                            var name_1 = names[0];
                            if (name_1 && name_1.textContent && title && title.textContent) {
                                lyr.id = parseInt(name_1.textContent, 0);
                                lyr.name = name_1.textContent + "  " + title.textContent;
                            }
                            _this.dynamicMapServiceResult.layers.push(lyr);
                        }
                    });
                    _this.fetchSuccess = true;
                }
                else {
                    _this.warnMsg = 'No layer information found for this WMS Service';
                }
            }
            else {
                _this.warnMsg = 'Error retrieving WMS Service Capabilities';
            }
            _this.loadingInd = false;
        });
    };
    AddExternalLayerComponent.prototype.inputFile = function () {
        var inputElement = this.fileInput.nativeElement;
        this.fileInput.files = [];
        inputElement.click();
    };
    AddExternalLayerComponent.prototype.fileChangeEvent = function (e) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var inputFileElement;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        inputFileElement = e.target;
                        return [4 /*yield*/, this.importService.importFiles(e)];
                    case 1:
                        _a.sent();
                        inputFileElement.value = ''; // Helps force change if same file selected again.
                        this.close();
                        return [2 /*return*/];
                }
            });
        });
    };
    AddExternalLayerComponent.prototype.close = function () {
        this.resetForm();
        this.onclose.emit();
    };
    return AddExternalLayerComponent;
}(BaseComponent));
export { AddExternalLayerComponent };
